module.exports = new __parcel__URL__("GenericError.cd21964e.svg").toString();